import axios from 'axios';
import { API_URL } from 'config';

const API_VERSION = 'v3';

const http = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

class ApiService {
  coupons = id => {
    return http.get(`${API_VERSION}/coupon_olds/${id}`);
  };

  validateCoupon = (id, couponCode, plateNumber) => {
    return http.post(`${API_VERSION}/coupon_olds/${id}/validate`, {
      coupon_old_code: couponCode,
      plate_number: plateNumber,
    });
  };

  couponRedeem = (id, couponCode, plateNumber, email, mobile) => {
    return http.post(`${API_VERSION}/coupon_olds/${id}/redeem`, {
      coupon_old_code: couponCode,
      plate_number: plateNumber,
      mobile,
      email,
    });
  };
}

export default new ApiService();
